<template>
  <!-- <ErrorHandler> -->
  <router-view />
  <!-- </ErrorHandler> -->
</template>
<script>
import ErrorHandler from '@/components/shared/ErrorHandler.vue'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  components: {
    ErrorHandler,
  },
  created() {
    if (this.$store.getters['auth/isSignedIn']) {
      Cookies.set('isHavetAdmin', 'true', { domain: 'havet.nu' })
    }
  },
}
</script>
<style lang="less">
@import './components/shared/editor/editorThemes/havet.less';
@import './components/shared/editor/editorThemes/livet.less';
@import './components/shared/editor/editorThemes/havsutsikt.less';
.d-flex {
  display: flex;
  gap: 15px;
}
.w-100 {
  width: 100%;
}
.video-iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  margin-bottom: 10px;
  .video-iframe {
    border: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

.ProseMirror-selectednode {
  outline: 2px solid #68cef8;
}
.vue-advanced-cropper__foreground {
  background: #fff !important;
}
</style>
